const LOCATIONS = {
  US:   'us',
  EU:   'eu',
  APAC: 'apac',
};

const LOCATIONS_LIST = [
  { name: 'US', id: LOCATIONS.US },
  { name: 'EU', id: LOCATIONS.EU },
  { name: 'APAC', id: LOCATIONS.APAC },
];

export default { LOCATIONS, LOCATIONS_LIST };
